import type { Project } from '@/types';

export function getProjectAvenueName(project: Project): string | undefined {
  return project.avenue?.name ?? project.districtAvenue?.name;
}

export function getProjectAvenueId(project: Project): string | undefined {
  return project.avenueId ?? project.avenue?.id ?? project.districtAvenue?.id;
}
